// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import UserInfoSvg from '@rsuite/icon-font/lib/people/UserInfo';
var UserInfo = createSvgIcon({
  as: UserInfoSvg,
  ariaLabel: 'user info',
  category: 'people',
  displayName: 'UserInfo'
});
export default UserInfo;